import { Controller } from "@hotwired/stimulus"
import { keepSubItemsExpanded, setKeepSubItemsExpanded } from "../lib/list_sub_items_preference"

// FD-901: the Display menu's "keep sub-items expanded" switch. Flips the stored
// preference and tells every row's sub-items controller on the page to follow it. The
// check/circle icons are both server-rendered; this only picks which one shows, since
// the server cannot know a localStorage value.
export default class extends Controller {
  static targets = ["on", "off"]

  connect() {
    // Held here too, so the switch still flips when storage is unavailable.
    this.expanded = keepSubItemsExpanded()
    this.#render(this.expanded)
  }

  toggle(event) {
    event.preventDefault()
    this.expanded = !this.expanded
    setKeepSubItemsExpanded(this.expanded)
    this.#render(this.expanded)
  }

  #render(expanded) {
    this.element.setAttribute("aria-pressed", String(expanded))
    this.element.classList.toggle("border-brand", expanded)
    this.element.classList.toggle("text-on-surface", expanded)
    this.onTarget.hidden = !expanded
    this.offTarget.hidden = expanded
  }
}
